import React from 'react'

const MobileFilterContext = React.createContext({
  active: '',
  setActivePanel: () => {},
})

export { MobileFilterContext }
